// The material the editor works on: the active material tab's, the
// material SELECTED in the library (the library detail edits a material in
// place, library layout 2026-10-01), or the Studio's front open document
// (the desk edits it where it lies). One derivation, so the editor host's
// load fan-out, the quality dock, the export flow and a compose turn all
// follow the same material. Pure and total.

import type {
    ActiveTab,
    MaterialRef,
    ResourceId,
    ResourceRef,
} from "../../components/Navigation/types.js";
import type { Library } from "../ports.js";
import { qualityVersionOf } from "./rightPanel/useMaterialQualities.js";

export const editedMaterialRef = (
    active: ActiveTab,
    refFor: (id: ResourceId) => ResourceRef | undefined,
    studioDocument?: ResourceId,
): MaterialRef | null => {
    const id =
        active.type === "resource"
            ? active.id
            : active.type === "search"
              ? active.selectedId
              : active.type === "studio"
                ? studioDocument
                : undefined;
    const ref = id === undefined ? undefined : refFor(id);
    return ref?.type === "material" ? ref : null;
};

// The edited material's version, read off the library: its row's last edit
// and grounding revision (`qualityVersionOf`) and how many suggestions await
// review on it (the library's needs-attention count). The editor's load keys
// on it, so when the material is written elsewhere (the assistant's tools, a
// generation job landing its text, another tab or machine) or a suggestion is
// made or resolved, the open page re-reads it as soon as the library shows the
// change. A suggestion does not edit the material, so its own row stays as it
// was; a kept one does, so its edit moves the row as well. Undefined: no row.
export const editedMaterialVersion = (
    library: Library | null,
    materialId: string | null,
): string | undefined => {
    const row = library?.materials.find((m) => m.id === materialId);
    const pending =
        library?.issues.find(
            (i) => i.type === "proposals" && i.resourceId === materialId,
        )?.count ?? 0;
    return row === undefined
        ? undefined
        : `${qualityVersionOf(row) ?? ""}#${pending}`;
};
